/**
 * REDUX STORE WRAPPER
 *
 * Wraps a component passing it some specified parts of the Redux store or the whole store.
 */

import React from 'react';

import reduxStore from './../../../reduxStore';

/**
 * Wraps a component giving it access to the Redux store.
 *
 * @param  {React.Component} Component    The component to be wrapped.
 * @param  {Array<string>}   storeParts   The parts of the Redux store to be passed to the component. The parts can also
 *                                        have the following syntax: ['storePart1.level1.level2.etc', 'storePart2'].
 *                                        Thus, having the possibility to access the Redux store at any level.
 * @return {React.Component}              The wrapped component.
 */
export default function withStore(Component, storeParts = 'all') {

    return class ComponentWithReduxStore extends React.Component {

        constructor(props) {
            super(props);

            this.buildNewState = this.buildNewState.bind(this);

            if (storeParts === 'all') {
                this.state = reduxStore.getState();
            } else {
                this.state = this.buildNewState();
            }
        }

        componentWillMount() {
            this.unsubscribe = reduxStore.subscribe(() => {
                if (storeParts === 'all') {
                    this.setState(reduxStore.getState());
                } else {
                    this.setState(this.buildNewState());
                }
            });
        }

        componentWillUnmount() {
            this.unsubscribe();
        }

        buildNewState() {
            let newState = {};

            for (let i = 0; i < storeParts.length; i++) {

                let storePartPath = storeParts[i].split('.'), // Split the specified Redux store object tree path
                    lastLevel = storePartPath[storePartPath.length - 1],
                    store = reduxStore.getState(),
                    storePart = store;

                // Recursively traverse the specified Redux store tree path in order to fetch the specified section
                for (let j = 0; j < storePartPath.length; j++) {
                    storePart = storePart[storePartPath[j]];
                }

                newState[lastLevel] = storePart;
            }

            return newState;
        }

        render() {
            return (
                <Component {...this.props} store={this.state} />
            );
        }

    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Wrappers/StoreWrapper/StoreWrapper.jsx